import { createFetchReducer } from '@copilot/common/store/reducers/fetch';
import { SENT_MESSAGES } from './constant';

export default createFetchReducer(SENT_MESSAGES);
